import { render, staticRenderFns } from "./NewsViewPage.vue?vue&type=template&id=62c84780&scoped=true&"
import script from "./NewsViewPage.vue?vue&type=script&lang=js&"
export * from "./NewsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c84780",
  null
  
)

export default component.exports